module.exports = __webpack_public_path__ + "static/img/YAX.69aaa4cb.png";